// extracted by mini-css-extract-plugin
module.exports = {"root":"order_root__KQgkd","table":"order_table__3YhSb","coupon":"order_coupon__3aSQg"};